import { z } from "zod";
import formatStringNumberToNumber from "../components/utils/formatStringNumberToNumber";

const formEditClaniceFinanceSchema = z
  .object({
    nacrtovanaVrednost: z.preprocess(
      (value) => formatStringNumberToNumber(value),
      z.number().nullable().optional(),
    ),
    nacrtovanaLastnaVrednost: z.preprocess(
      (value) => formatStringNumberToNumber(value),
      z.number().nullable().optional(),
    ),
    nacrtovanaVrednostViri: z.preprocess(
      (value) => formatStringNumberToNumber(value),
      z.number().nullable().optional(),
    ),
    nacrtovaniObseg: z.preprocess(
      (value) => (isNaN(value) ? null : value),
      z.number().nullable().optional(),
    ),
  })
  .superRefine(
    (
      { nacrtovanaVrednost, nacrtovanaLastnaVrednost, nacrtovanaVrednostViri },
      ctx,
    ) => {
      const sestevekVrednostiVirov =
        (nacrtovanaLastnaVrednost || 0) + (nacrtovanaVrednostViri || 0);

      if (sestevekVrednostiVirov > nacrtovanaVrednost) {
        ctx.addIssue({
          message:
            "Lastno sofinanciranje in sofinanciranje iz projektnega vira ne smeta presegati vrednosti projekta",
          path: ["nacrtovanaVrednost"],
        });
      }
    },
  );

export default formEditClaniceFinanceSchema;
